import { DateRangeSelection } from 'src/models/common';

const isDateRangeSelection = (value: unknown): value is DateRangeSelection => {
	return (
		value !== null &&
		typeof value === 'object' &&
		'from' in value &&
		'to' in value &&
		typeof value.from === 'string' &&
		typeof value.to === 'string'
	);
};

export const parseActivityListDateRouteParam = (dateParam: unknown): DateRangeSelection | null | string => {
	if (typeof dateParam !== 'string') {
		return null;
	}

	try {
		const parsedDateParam = JSON.parse(dateParam) as unknown;

		if (typeof parsedDateParam === 'string') {
			return parsedDateParam;
		}

		if (isDateRangeSelection(parsedDateParam)) {
			return {
				from: parsedDateParam.from,
				to: parsedDateParam.to,
			};
		}
	} catch {
		return dateParam;
	}

	return dateParam;
};

export const serializeActivityListDateRouteParam = (date: DateRangeSelection | string): string => {
	if (typeof date === 'string') {
		const parsedDate = parseActivityListDateRouteParam(date);

		if (typeof parsedDate === 'string') {
			return parsedDate;
		}

		if (parsedDate !== null) {
			return JSON.stringify(parsedDate);
		}

		return date;
	}

	return JSON.stringify(date);
};
